export const RatingsInputDataHooks = {
  RatingStarWrapper: 'ratings-input-rating-star-wrapper',
  RatingStar: 'ratings-input-rating-star',
  Container: 'ratings-input-container',
  Label: 'ratings-input-label',
  ReactionLabel: 'ratings-input-reaction-label',
};

export const RatingsInputDataKeys = {
  Error: 'data-error',
  Disabled: 'data-disabled',
  Size: 'data-size',
  Layout: 'data-layout',
  Active: 'data-active',
};
